<template>
  <div id="subOutputRank-print" class="page-break">
    <el-row>
      <el-col :span="6" :offset="9">
        <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000">送货验收单</h1>
      </el-col>
    </el-row>
    <el-row style="margin-top:50px;">
      <el-col :span="3">
        <img :src="imgUrl" style="width: 92%">
      </el-col>
      <el-col v-if="topData.length > 0" :span="9">
        <ul>
          <li>供&nbsp;&nbsp;应&nbsp;&nbsp;商：{{ printName || topData[0].SUPPLIER_NAME }}</li>
          <li>项&nbsp;&nbsp;目&nbsp;&nbsp;点：{{ topData[0].PROJECT_NAME }}</li>
          <li>项目点地址：{{ topData[0].PROJECT_ADDRESS }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期：{{ topData[0].SEND_DAY }}</li>
        </ul>
      </el-col>
      <el-col :span="12" style="padding-left: 70px">
        <ul>
          <li>制&nbsp;&nbsp;单&nbsp;&nbsp;人：{{ managername }}</li>
          <li>档&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;口：{{ topData[0].DK_NAME }}</li>
          <li>{{ topData[0].PROJECT_TELPHONE }}</li>
          <li>订&nbsp;单&nbsp;编号：{{ topData[0].ORDER_CODE }}</li>
          <li v-if="topData[0].SHOW_PRICE == 1">总&nbsp;金&nbsp;额：{{ topData[0].TOTAL_PROJECT_FEE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <table style="width: 100%">
          <tr>
            <th style="width: 5%">序号</th>
            <th style="width: 40%">名称</th>
            <th style="width: 5%">单位</th>
            <th style="width: 10%" v-if="sendFlag == 0">订购</th>
            <th style="width: 10%" v-if="sendFlag == 1">送货数量</th>
            <th style="width: 10%">实收</th>
            <th v-if="topData[0].SHOW_PRICE == 1" style="width: 10%">价格</th>
            <th v-if="topData[0].SHOW_PRICE == 1" style="width: 10%">总金额</th>
            <th style="width: 15%">备注</th>
          </tr>
          <tr v-for="(item, index) in mainData[0]" :key="index">
            <td>{{ item.ID }}</td>
            <td>{{ item.PRODUCT_NAME }}</td>
            <td>{{ item.TYPE_UNIT }}</td>
            <td v-if="sendFlag == 0">{{ item.PRODUCT_COUNT }}</td>
            <td v-if="sendFlag == 1">{{ item.NEED_COUNT }}</td>
            <td></td>
            <td v-if="topData[0].SHOW_PRICE == 1">{{ item.PROJECT_PRICE }}</td>
            <td v-if="topData[0].SHOW_PRICE == 1 && sendFlag == 0">{{ item.PROJECT_TOTAL_FEE }}</td>
            <td v-if="topData[0].SHOW_PRICE == 1 && sendFlag == 1">
              {{ Math.round((item.NEED_COUNT * item.PROJECT_PRICE) * 100) / 100 }}
            </td>
            <td>{{ item.PRODUCT_COMMENT }}</td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="18">
        <span>收货时间：</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>送货员：</span>
      </el-col>
      <el-col :span="6">
        <span>项目经理：</span>
      </el-col>
      <el-col :span="6">
        <span>厨师长：</span>
      </el-col>
      <el-col :span="6">
        <span>验收人员：</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" :offset="21" style="padding: 0">
        <p>第{{ mainData[0].currentPage }}页/共{{ mainData[0].totalPage }}页</p>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    manager: String,
    supplier: String,
  },
  data() {
    return {
      topData: [],
      mainData: [],
      managername: '',
      imgUrl: '',
      printSupplier: '',
      printName: sessionStorage.getItem('supplierName'),
      sendFlag: sessionStorage.getItem('sendFlag'),
    };
  },
  created() {
    this.topData = this.headerData;
    this.mainData.push(this.tableData);
    this.managername = this.manager;
    this.printSupplier = this.supplier;
    this.imgUrl = `https://service.linkda.com.cn/file/barcode/${this.topData[0].ORDER_ID}.png`;
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}

li {
  list-style: none;
  font-size: 20px;
  line-height: 30px;
  color: #000;
  font-family: 黑体;
}

span {
  font-size: 20px;
  line-height: 35px;
  color: #000;
  font-family: 黑体;
}

table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
}

td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 22px;
  height: 30px;
  font-family: 黑体;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/newDSOrderNewTaxCus.vue